import { types } from './types';
import { instance } from 'store/utils';
import { clearForm } from 'store/forms/actions';
import { clearApptrack } from 'store/appTrack/actions';
import { message } from 'antd';

const loginEndpoint = '/app/authentication';
const getOAuth2ClientsEndpoint = '/app/oauth2-clients';
const loginCheckerEndpoint = '/app/rest/account-checker';
const askTempPasswordEndpoint = '/app/temp-password';
const setNewPasswordEndpoint = '/app/rest/new-password';

export const confirmLogin = (payload, navigate, callback) => dispatch => {
  dispatch({ type: types.GET_USER_DATA.START });
  instance
    .post(`/app/authentication`, payload)
    .then(response => {
      const payloadR = {
        j_username: payload.j_username,
        j_password: payload.j_password,
        _spring_security_remember_me: payload._spring_security_remember_me,
        submit: payload.submit,
        status: response.status,
        date: response.headers.date,
      };

      dispatch({
        type: types.GET_USER_DATA.SUCCESS,
        payload: payloadR,
      });

      // Remove the check for mustChangePassword here, as it will be handled in checkUser action
      navigate('/appTrack');
      callback(false);
    })
    .catch(error => {
      console.log('error login:', error);
      dispatch({
        type: types.GET_USER_DATA.ERROR,
      });
      callback(true);
    });
};

export const getTaxisData = taskId => dispatch => {
  dispatch({ type: types.GET_TAXIS_DATA.START });
  instance
    .get('/app/rest/taxis-details')
    .then(response => {
      dispatch({
        type: types.GET_TAXIS_DATA.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_TAXIS_DATA.ERROR });
    });
};

export const getTaxisDataByTk = tk => dispatch => {
  dispatch({ type: types.GET_TAXIS_DATA_BY_TK.START });
  instance
    .get(`/app/rest/account/findInfoByZip/${tk}`)
    .then(response => {
      console.log(response.data);
      dispatch({
        type: types.GET_TAXIS_DATA_BY_TK.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_TAXIS_DATA_BY_TK.ERROR });
    });
};

// export const login = (username, password) => async (dispatch) => {
//   dispatch({ type: types.LOGIN.START });
//   try {
//     const response = await instance.post(loginEndpoint, { username, password });
//     console.log('Login response:', response.data);
//     dispatch({ type: types.LOGIN.SUCCESS, payload: response.data });
//   } catch (error) {
//     console.error('Login failed:', error);
//     dispatch({ type: types.LOGIN.ERROR, payload: error.message });
//   }
// };

export const login = (username, password, navigate) => async dispatch => {
  dispatch({ type: types.LOGIN.START });
  try {
    const response = await instance.post(loginEndpoint, { username, password });
    console.log('Login response:', response.data);

    if (response.data.mustChangePassword) {
      navigate('/go-beyond/new-password');
    } else {
      dispatch({ type: types.LOGIN.SUCCESS, payload: response.data });
      navigate('/appTrack');
    }
  } catch (error) {
    console.error('Login failed:', error);
    dispatch({ type: types.LOGIN.ERROR, payload: error.message });
  }
};

export const initiateLoginFlow = params => dispatch => {
  dispatch({ type: types.LOGIN_START });
  //confirmLogin?
};

export const initiateGsisLogin = () => dispatch => {
  // const protocol = 'http://';
  const host = process.env.REACT_APP_BACKEND_GSIS_HOST;
  // const port = process.env.REACT_APP_FRONTEND_HOST_GSIS_PORT;
  // const backendPath = process.env.REACT_APP_BACKEND_FLOWABLE_CONTEXT_PATH;
  const authClient = process.env.REACT_APP_AUTH2_CLIENT;

  const gsisAuthUrl = `${host}/oauth2/authorization/${authClient}`;

  console.log('Constructed GSIS Auth URL:', gsisAuthUrl);

  window.location.href = gsisAuthUrl;
};

// export const initiateGsisLogin = (gsisAuthUrl) => () => {
//   window.location.href = gsisAuthUrl;
// };

export const getOAuth2Clients = () => async dispatch => {
  dispatch({ type: types.GET_OAUTH2_CLIENTS.START });
  try {
    const response = await instance.get(getOAuth2ClientsEndpoint);
    console.log('OAuth2 Clients response:', response.data);
    dispatch({
      type: types.GET_OAUTH2_CLIENTS.SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error('Failed to fetch OAuth2 clients:', error);
    dispatch({ type: types.GET_OAUTH2_CLIENTS.ERROR, payload: error.message });
  }
};

export const setNewPassword = (newPassword) => async (dispatch) => {
  dispatch({ type: types.SET_NEW_PASSWORD.START });
  try {
    const response = await instance.post(setNewPasswordEndpoint, {
      password: newPassword,
    });
    console.log('Set new password response:', response.data);
    dispatch({ type: types.SET_NEW_PASSWORD.SUCCESS, payload: response.data });
  } catch (error) {
    console.error('Set new password failed:', error);
    dispatch({ type: types.SET_NEW_PASSWORD.ERROR, payload: error.message });
  }
};

export const requestTempPassword = email => async dispatch => {
  dispatch({ type: types.REQUEST_TEMP_PASSWORD.START });
  try {
    const response = await instance.post(askTempPasswordEndpoint, { email });
    console.log('Temp password request response:', response.data);
    dispatch({
      type: types.REQUEST_TEMP_PASSWORD.SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error('Temp password request failed:', error);
    const errorMessage = error.response?.data?.message || 'An error occurred while requesting the temporary password';
    dispatch({
      type: types.REQUEST_TEMP_PASSWORD.ERROR,
      payload: errorMessage,
    });
  }
};

export const checkLoginStatus = () => async dispatch => {
  dispatch({ type: types.CHECK_LOGIN.START });
  try {
    const response = await instance.get(loginCheckerEndpoint);
    console.log('Login check response:', response.data);
    dispatch({ type: types.CHECK_LOGIN.SUCCESS, payload: response.data });
  } catch (error) {
    console.error('Login check failed:', error);
    dispatch({ type: types.CHECK_LOGIN.ERROR, payload: error.message });
  }
};

export const logoutUser = () => dispatch => {
  const url = '/app/logout';
  dispatch({ type: types.LOGOUT_USER.START });
  instance
    .get(url)
    .then(response => {
      dispatch({ type: types.LOGOUT_USER.SUCCESS, payload: response.data });
      window.location.href = `${window.location.protocol}//${
        window.location.hostname
      }${
        window.location.hostname === 'localhost'
          ? process.env.REACT_APP_FRONTEND_HOST_PORT
          : ''
      }/go-beyond/login`;
    })
    .catch(error => {
      if(error.code==='ERR_NETWORK'){
      window.location.href = `${window.location.protocol}//${
        window.location.hostname
      }${
        window.location.hostname === 'localhost'
          ? process.env.REACT_APP_FRONTEND_HOST_PORT
          : ''
      }/go-beyond/login`;
      }
      dispatch({ type: types.LOGOUT_USER.ERROR, payload: error.message });
    });
 
};

export const getUser = () => dispatch => {
  const url = '/app/rest/account-extended';
  dispatch({ type: types.GET_USER.START });
  instance
    .get(url)
    .then(response => {
      dispatch({ type: types.GET_USER.SUCCESS, payload: response.data });
    })
    .catch(error => {
      dispatch({ type: types.GET_USER.ERROR, payload: error.message });
    });
};

export const checkUser = navigate => dispatch => {
  const url = '/app/rest/account-checker';
  dispatch({ type: types.CHECK_USER.START });
  instance
    .get(url)
    .then(response => {
      dispatch({ type: types.CHECK_USER.SUCCESS, payload: response.data });

      if (response.data.mustChangePassword) {
        navigate('/new-password');
      }
    })
    .catch(error => {
      dispatch({ type: types.CHECK_USER.ERROR, payload: error.message });
      dispatch(clearForm());
      dispatch(clearApptrack());
      dispatch(clearUser());
      navigate('/login');
      window.location.reload();
    });
};

export const checkUserLogged = (navigate, callback) => dispatch => {
  const url = '/app/rest/account-checker';
  dispatch({ type: types.CHECK_USER.START });
  instance
    .get(url)
    .then(response => {
      dispatch({ type: types.CHECK_USER.SUCCESS, payload: response.data });

      if (response.data.mustChangePassword) {
        navigate('/new-password');
        callback(false);
      } else {
        callback(true);
      }
    })
    .catch(error => {
      dispatch({ type: types.CHECK_USER.ERROR, payload: error.message });
      dispatch(clearForm());
      dispatch(clearApptrack());
      dispatch(clearUser());
      navigate('/login');
      callback(false);
      window.location.reload();
    });
};

export const requestPasswordReset = email => async dispatch => {
  dispatch({ type: types.REQUEST_PASSWORD_RESET.START });
  try {
    // API call to request password reset
    const response = await instance.post('/app/temp-password', { email });
    dispatch({ type: types.REQUEST_PASSWORD_RESET.SUCCESS });
    return response.data;
  } catch (error) {
    dispatch({
      type: types.REQUEST_PASSWORD_RESET.ERROR,
      payload:
        error.response?.data?.message ||
        'An error occurred while resetting the password',
    });
    throw error;
  }
};

export const setRememberMe = value => ({
  type: types.UPDATE_USER.SUCCESS,
  payload: { rememberMe: value },
});

export const clearUser = () => dispatch => {
  dispatch({ type: types.CLEAR_USER });
};

export const resetUser = () => ({
  type: types.RESET_USER,
});

export const changePassword =
  (newPassword, confirmPassword) => async dispatch => {
    dispatch({ type: types.CHANGE_PASSWORD.START });
    try {
      // API? na to brw
      // const response = await instance.post('/api/change-password', { newPassword, confirmPassword });
      dispatch({ type: types.CHANGE_PASSWORD.SUCCESS });
    } catch (error) {
      dispatch({
        type: types.CHANGE_PASSWORD.ERROR,
        payload: error.response?.data?.message || 'Failed to change password',
      });
    }
  };
